'use client';

import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

export default function SpaceshipAnimation() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 8000);
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ x: -200, y: 100, rotate: -15, opacity: 0 }}
      animate={{ 
        x: window.innerWidth + 200, 
        y: 50, 
        rotate: 15, 
        opacity: [0, 1, 1, 0] 
      }}
      transition={{ 
        duration: 8, 
        ease: "easeInOut",
        opacity: { times: [0, 0.1, 0.9, 1] }
      }}
      className="fixed top-1/4 z-30 pointer-events-none"
    >
      {/* Nave espacial */}
      <div className="relative">
        {/* Corpo principal */}
        <div className="w-16 h-4 bg-gradient-to-r from-gray-300 to-white rounded-full relative">
          {/* Cockpit */}
          <div className="absolute -top-1 left-2 w-6 h-6 bg-gradient-to-br from-white to-gray-200 rounded-full border-2 border-gray-400" />
          
          {/* Asas */}
          <div className="absolute -top-2 -left-2 w-4 h-8 bg-gradient-to-b from-gray-400 to-gray-600 transform -skew-x-12 rounded-l" />
          <div className="absolute -bottom-2 -left-2 w-4 h-8 bg-gradient-to-t from-gray-400 to-gray-600 transform skew-x-12 rounded-l" />
          
          {/* Propulsores */}
          <div className="absolute top-1 -right-2 w-3 h-2 bg-gradient-to-r from-gray-500 to-gray-700 rounded-r" />
          <div className="absolute bottom-1 -right-2 w-3 h-2 bg-gradient-to-r from-gray-500 to-gray-700 rounded-r" />
        </div>

        {/* Rastro de propulsão */}
        <motion.div
          animate={{ 
            scaleX: [0.5, 1, 0.8, 1.2, 0.6],
            opacity: [0.8, 1, 0.6, 1, 0.4]
          }}
          transition={{ 
            duration: 0.5, 
            repeat: Infinity,
            repeatType: "reverse"
          }}
          className="absolute top-1/2 -right-8 transform -translate-y-1/2 w-12 h-1 bg-gradient-to-r from-blue-400 via-white to-transparent rounded-full"
        />
        
        {/* Partículas de escape */}
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            animate={{
              x: [-10 - i * 3, -30 - i * 5],
              y: [Math.random() * 6 - 3, Math.random() * 10 - 5],
              opacity: [1, 0],
              scale: [0.5, 0.1]
            }}
            transition={{
              duration: 0.8,
              repeat: Infinity,
              delay: i * 0.1,
              repeatType: "loop"
            }}
            className="absolute top-1/2 right-0 w-1 h-1 bg-white rounded-full"
          />
        ))}
      </div>
    </motion.div>
  );
}